<div [hidden]="!isVisible">
    @if (useDS) {
        <div class="tooltip">
            <div class="lh-tooltip-h">{{ commonMessages.MinReq }}</div>

            <ul class="list-unstyled txt-s m-0">
                @for (tooltip of tooltips | keyvalue; track $index) {
                    <ng-container [ngTemplateOutlet]="tooltipTemplateDS" [ngTemplateOutletContext]="{ tooltip }" />
                }
            </ul>

            @if (infoTooltips?.length) {
                <ul class="list-unstyled txt-s info m-0">
                    @for (tooltip of infoTooltips | keyvalue; track $index) {
                        <ng-container [ngTemplateOutlet]="tooltipTemplateDS" [ngTemplateOutletContext]="{ tooltip }" />
                    }
                </ul>
            }
        </div>
    } @else {
        <div class="tooltip">
            <div class="lh-tooltip-h">{{ commonMessages.MinReq }}</div>

            <ul class="list-unstyled txt-s m-0">
                @for (tooltip of tooltips | keyvalue; track $index) {
                    <ng-container [ngTemplateOutlet]="tooltipTemplate" [ngTemplateOutletContext]="{ tooltip }" />
                }
            </ul>

            @if (infoTooltips?.length) {
                <ul class="list-unstyled txt-s info m-0">
                    @for (tooltip of infoTooltips | keyvalue; track $index) {
                        <ng-container [ngTemplateOutlet]="tooltipTemplate" [ngTemplateOutletContext]="{ tooltip }" />
                    }
                </ul>
            }
        </div>
    }

    <ng-template #tooltipTemplateDS let-tooltip="tooltip">
        <li class="d-flex align-items-center">
            <ds-help-group>
                @if (tooltip.value.isValid === true) {
                    <ds-help-item type="success" inverse="false" [isRightAligned]="false">
                        <vn-icon slot="icon" name="theme-check" extraClass="ui-icon ui-icon-size-sm icon" />
                        <div slot="text" [innerHtml]="tooltip.value.text | trustAsHtml" class="txt-xs d-inline m-0"></div>
                    </ds-help-item>
                } @else if (tooltip.value.isValid === false) {
                    <ds-help-item type="error" inverse="false" [isRightAligned]="false">
                        <vn-icon slot="icon" name="theme-ex" extraClass="ui-icon ui-icon-size-sm icon" />
                        <div slot="text" [innerHtml]="tooltip.value.text | trustAsHtml" class="txt-xs d-inline m-0"></div>
                    </ds-help-item>
                } @else if (tooltip.value.isValid) {
                    <ds-help-item type="info" inverse="false" [isRightAligned]="false">
                        <vn-icon slot="icon" name="theme-info-i" extraClass="ui-icon ui-icon-size-sm icon" />
                        <div slot="text" [innerHtml]="tooltip.value.text | trustAsHtml" class="txt-xs d-inline m-0"></div>
                    </ds-help-item>
                }
            </ds-help-group>
        </li>
    </ng-template>

    <ng-template #tooltipTemplate let-tooltip="tooltip">
        <li class="d-flex align-items-center">
            @if (tooltip.value.isValid === true) {
                <vn-icon name="theme-check" extraClass="ui-icon ui-icon-size-sm icon" />
            } @else if (tooltip.value.isValid === false) {
                <vn-icon name="theme-ex" extraClass="ui-icon ui-icon-size-sm icon" />
            } @else if (tooltip.value.isValid) {
                <vn-icon name="theme-info-i" extraClass="ui-icon ui-icon-size-sm icon" />
            }
            <div [innerHtml]="tooltip.value.text | trustAsHtml" class="txt-xs d-inline m-0"></div>
        </li>
    </ng-template>
</div>
